import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ActivityService } from '../shared/activity.service';
import { MessageService } from '../shared/message.service';
import { MessageType } from '../shared/messageType';
import { PKCEHelperService } from '../services/pkcehelper.service';
import { environment } from '../../environments/environment';
import { IdmUtilities } from '@platform-idm/sdk-javascript';
import { PlatformIdmService } from '@platform-idm/sdk-angular';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  currentDate = new Date();
  copyrightYear = this.currentDate.getFullYear();

  constructor(
    private router: Router,
    private activityService: ActivityService,
    private messages: MessageService,
    private ngZone: NgZone,
    private route: ActivatedRoute,
      private pkce: PKCEHelperService,
    private auth: PlatformIdmService
  ) {
  }



  async ngOnInit() {
    let utility = new IdmUtilities();

    var crmId = utility.getQueryVariable('mx.crmId');
    if (crmId) 
      this.auth.authentication.getOptions().crmId = crmId;

    var dd = utility.getQueryVariable('mx.dd');
    if (dd) 
      this.auth.authentication.getOptions().defaultDomain = dd;

    this.auth.authentication.login(); 
    }

 

  redirectToForgotPasswordSSO() {

    const userName = (<HTMLInputElement>document.querySelector('input[name=username]')).value;
    if (userName) {
      let navigationExtras: NavigationExtras = {
        queryParams: { 'userName': userName },
      };
      // Navigate to the reset-password page with extras
      //Not sure why it worked before. but router should be run inside Angular context.
      //After upgrading to widget 3.6.9 it stop working, so lets us ngzone to run it inside Angular
      this.ngZone.run(() => {
        this.router.navigate(['/reset-password'], navigationExtras);
      });
    } else {
      // error
    }
  }

  private hideInvalidLoginMessage() {
    const errorContainer = document.getElementsByClassName('o-form-error-container')[0];
    errorContainer.innerHTML = '';

  }

  private displayInvalidLoginMessage() {
    const errorContainer = document.getElementsByClassName('o-form-error-container')[0];
    errorContainer.className = 'o-form-error-container o-form-has-errors';
    const errorHtml = '<div>	    <div class="okta-form-infobox-error infobox infobox-error" role="alert">	      <span class="icon error-16"></span>	      	        <p>Sign in failed!</p>	      	    </div>	  </div>';
    errorContainer.innerHTML = errorHtml;
  }
}
